import ADataTableHeader from './index.vue';

ADataTableHeader.install = app => {
  app.component(ADataTableHeader.name, ADataTableHeader);
};

export default ADataTableHeader;
